import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
const isIframe = window !== window.parent && !window.opener;
const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    loadChildren: () =>
      import('./components/adminLayout/admin.module').then(
        (m) => m.AdminModule
      ),
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppAdminRoutingModule { }
